import type { Phoneme } from "../../content/types";
import { Ring } from "../../components";

type PhonemeCellProps = { phoneme: Phoneme; mastery: number; onOpen: (phoneme: Phoneme) => void };

export function PhonemeCell({ phoneme, mastery, onOpen }: PhonemeCellProps) {
  const heat = mastery / 5;
  return (
    <button
      type="button"
      class="phoneme-cell"
      style={{ background: `color-mix(in srgb, var(--accent) ${Math.round(heat * 100)}%, var(--bg-sunken))` }}
      onClick={() => onOpen(phoneme)}
    >
      <span class="mono phoneme-cell-label">{phoneme.label}</span>
      <Ring segments={5} filled={mastery} size={30} strokeWidth={3} />
    </button>
  );
}
